<template>
  <v-container>
    
  </v-container>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  name: "Parcelamento",
});
</script>